(function($) {
  // Panels hebben class component-panel
  // Panels hebben unique ID

  // $panel = component('Panel');
  // $panel->record();

  // // Panel content
  // echo '<button data-panel-close="SiteHeader">X</button>';
  // echo apply_filters('the_content', $homepage['post']->post_content);
  // // / Panel content

  // $panel->render([
  //   'id' => 'SiteHeader', 
  //   'class' => 'site-header-panel'
  // ]);

  // OpenPanel link <button data-panel-open="{{id}}"></button>
  // OpenPanel met Ajax <button data-panel-load="{{id}}"></button>
  // Gebruik $(['data-panel-load="{{id}}"']).on('click' ... ) voor het aanroepen van Ajax
  // Voorbeeld ulysses.bwhontwerpers.nl > gutenbergblock > episode-swiper panel + theme.js

  var $panels = $('.component-panel');

  function panel_enable( id ) {
    $('body').css('overflow','hidden');
    $(`#${id}Wrapper`).addClass('component-panel--enabled');
  }

  function panel_disable( id ) {
    $(`#${id}Wrapper`).removeClass('component-panel--enabled');
    $('body').css('overflow','auto');
  }

  function panel_open( id ) {
    var $wrapper = $(`#${id}Wrapper`);
    if( $wrapper.hasClass('component-panel--enabled') ) { // mogelijk via loader
      $wrapper.addClass('component-panel--open');
    } else {
      panel_enable(id);
      setTimeout( function() {
        $(`#${id}Wrapper`).addClass('component-panel--open');
      }, 50 );
    }
  }

  function panel_close( id ) {
    $(`#${id}Wrapper`).removeClass('component-panel--open');
    setTimeout( function() {
      panel_disable( id );
    }, 350 );
  }

  function panel_loading_start( id ) {
    panel_enable(id);
    setTimeout( function() {
      $(`#${id}Loader`).addClass('component-loader--active');
    }, 50 );
    // panel_open handmatig, houdt hier rekening mee
  }

  function panel_loading_end( id ) {
    $(`#${id}Loader`).removeClass('component-loader--active');
  }


  function init() {
    window.panel_loading_start = panel_loading_start;
    window.panel_loading_end = panel_loading_end;
    window.panel_enable = panel_enable;
    window.panel_disable = panel_disable;
    window.panel_open = panel_open;
    window.panel_close = panel_close;

    $('[data-panel-open]').on('click', function(e) {
      e.preventDefault();
      var id = $(this).attr('data-panel-open');
      window.panel_open( id );
    })

    $('[data-panel-close]').on('click', function(e) {
      e.preventDefault();
      var id = $(this).attr('data-panel-close');
      window.panel_close( id );
    })

    $('.component-panel').bind('blur change click dblclick error focus focusin focusout hover keydown keypress keyup load mousedown mouseenter mouseleave mousemove mouseout mouseover mouseup resize scroll select submit', function(event){
      event.stopPropagation();
    });

  }

  if( $panels.length ) init();

})(jQuery);